import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StoreBasicInfo from 'components/StoreBasicInfo';
import TradingHours from 'components/TradingHours';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    location: PropTypes.shape({
        title: PropTypes.string,
        fullAddress: PropTypes.oneOfType([
            PropTypes.shape({
                address: PropTypes.string,
            }),
            PropTypes.string,
        ]),
        tradingHours: PropTypes.shape({
            monday: PropTypes.string,
            tuesday: PropTypes.string,
            wednesday: PropTypes.string,
            thursday: PropTypes.string,
            friday: PropTypes.string,
            saturday: PropTypes.string,
            sunday: PropTypes.string,
        }),
    }).isRequired,
};

/*
 * Component
 */
function LocationContactInfo({ location }) {
    if (!location) {
        return null;
    }

    const {
        title,
        fullAddress,
        tradingHours,
        headquarter,
    } = location;

    const name = headquarter ? 'Acai Headquarter' : 'Acai Brothers';

    return (
        <div className="location-contact-info">
            <div className="content">
                <StoreBasicInfo
                    name={`${name} - ${title}`}
                    address={
                        fullAddress
                        && fullAddress.address
                    }
                    large
                />
                <TradingHours tradingHours={tradingHours} />
            </div>
        </div>
    );
}

LocationContactInfo.propTypes = propTypes;

const mapStateToProps = state => ({
    location: state.locations[state.currentLocation],
});

export default connect(mapStateToProps)(LocationContactInfo);
